import { Action } from '@ngrx/store';
import { ActionTypes } from '../actions/layout';

export interface State {
  showProgressBar: boolean;
  pendingRequests: number;
  modalVisible: boolean;
}

export const initialState: State = {
  showProgressBar: false,
  pendingRequests: 0,
  modalVisible: false,
};

export function layoutReducer(state = initialState, action: Action) {
  switch (action.type) {
    case ActionTypes.ShowProgressBar:
      const newPendCounter = state.pendingRequests + 1;
      return {
        ...state,
        showProgressBar: true,
        pendingRequests: newPendCounter,
      };

    case ActionTypes.HideProgressBar:
      const newPendingCounter =
        state.pendingRequests > 0 ? state.pendingRequests - 1 : 0;
      const newPendState = newPendingCounter > 0;
      return {
        ...state,
        pendingRequests: newPendingCounter,
        showProgressBar: newPendState,
      };

    case ActionTypes.BlurMenu:
      return { ...state, modalVisible: true };

    case ActionTypes.UnblurMenu:
      return { ...state, modalVisible: false };

    default:
      return state;
  }
}

export const getProgressBarStatus = (state: State) => state.showProgressBar;
export const getModalStatus = (state: State) => state.modalVisible;
